import React from "react";
import { Link } from "react-router-dom";
import { Transition, Segment, Header, Grid, Label } from "semantic-ui-react";

class Listados extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState(state => ({ visible: true }));
  }
  componentWillUnmount() {
    this.setState(state => ({ visible: false }));
  }

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Segment textAlign="center">
            <Header as="h2">Listados Extraescolares</Header>
            <Grid columns={8}>
              <Grid.Column>
                <Link to="/listado/bajas">
                  <Label content="Listado de BAJAS" />
                </Link>
              </Grid.Column>
              <Grid.Column>
                <Link to="/extraescolares/listados/cobros">
                  <Label content="Listado de COBROS" />
                </Link>
              </Grid.Column>
              <Grid.Column>
                <Link to="/listado/historico-cobros">
                  <Label content="Histórico de COBROS" />
                </Link>
              </Grid.Column>
              <Grid.Column>
                <Link to="/listado/avisos">
                  <Label content="Listado de AVISOS" />
                </Link>
              </Grid.Column>
              <Grid.Column>
                <Link to="/listado/incidencias">
                  <Label content="Listado de INCIDENCIAS" />
                </Link>
              </Grid.Column>
            </Grid>
          </Segment>
        )}
      </Transition.Group>
    );
  }
}
export default Listados;



// WEBPACK FOOTER //
// ./src/pages/Listados.jsx